export default __webpack_public_path__ + "static/media/money_exchange.82f7e85b.png";